import script from "./ShowAppointment.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowAppointment.vue?vue&type=script&setup=true&lang=ts"

import "./ShowAppointment.vue?vue&type=style&index=0&id=b5bd19f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5bd19f4"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
